import { render } from "./RegisterSummary.vue?vue&type=template&id=0276ef74"
import script from "./RegisterSummary.vue?vue&type=script&lang=js"
export * from "./RegisterSummary.vue?vue&type=script&lang=js"

import "./RegisterSummary.vue?vue&type=style&index=0&id=0276ef74&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__